
















import Vue from 'vue';
import WxTplTemplateItem from './WxTplTemplateItem.vue';
import commonClient from '../../../../common/apis';
import scheduleRuleVuex from '../../../vuex/common';

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  components: {
    WxTplTemplateItem,
  },
  data() {
    return {
      templates: [],
      tipsImage: require('assets/img/wxtpl-template-tips.svg'),
    };
  },
  methods: {
    confirmTip() {
      commonClient.confirmCrmTip({scene: 'wx_tpl_template'});
      this.$store.commit('HIDE_WX_TPL_TEMPLATE_TIP');
    },
    loadTemplates() {
      commonClient.getWxTplTemplates().success((r: any) => {
        this.$store.commit('SET_WX_TPL_TEMPLATES', r.templates.map((r: any) => {
          const template = r;
          const parsed = JSON.parse(template.wxTpl);
          const out: any = {}
          Object.entries(parsed.params).forEach(([k, v]) => {
            const _v = v as any

            _v.value = (_v.value || '').replace(/<label[^>]*>\#(.*?)<\/label>/g, '<drip-prop contenteditable="false">#$1</drip-prop>').replace('&#8203;', '')
            out[k] = _v
            console.log(_v)
          })
          parsed.params = out
          template.wxTpl = parsed
          return template;
        }));
      });
    },
  },
  mounted() {
    this.loadTemplates();
  },
});
